const customProductFormSelector = 'product-form-component[data-custom-cart-drawer]';
const customCartFormSelector = 'form[data-custom-cart-drawer-form="true"]';
let isSyncingVariant = false;

/**
 * Uses Horizon's native fly-to-cart element for custom product forms.
 *
 * @param {MouseEvent} event
 */
function handleCustomCartAnimation(event) {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const button = target.closest('button[type="submit"]');
  if (!(button instanceof HTMLButtonElement) || button.disabled || button.closest('add-to-cart-component')) return;

  const form = button.form;
  if (!(form instanceof HTMLFormElement) || !form.matches(customCartFormSelector) || !form.checkValidity()) return;

  const component = form.closest(customProductFormSelector);
  if (!(component instanceof HTMLElement) || component.dataset.customCartAnimation !== 'true') return;

  const variantControl = form.elements.namedItem('id');
  let image = '';

  if (variantControl instanceof HTMLSelectElement) {
    image = variantControl.selectedOptions[0]?.dataset.customCartImage || '';
  } else if (variantControl instanceof HTMLInputElement) {
    image = variantControl.dataset.customCartImage || '';
  }

  image ||= component.dataset.customCartImage || '';

  const cartIcon = document.querySelector('.header-actions__cart-icon');
  if (!cartIcon || !image) return;

  const flyToCartElement = document.createElement('fly-to-cart');
  const isExternalFormButton = !button.closest('form');
  const isStickyButton =
    isExternalFormButton || Boolean(button.closest('[data-cpb-sticky], [data-sticky-atc], [data-cbh-sticky-atc]'));
  const animationClass = isStickyButton
    ? 'fly-to-cart--sticky'
    : component.closest('article')
      ? 'fly-to-cart--quick'
      : 'fly-to-cart--main';

  flyToCartElement.classList.add(animationClass);
  flyToCartElement.style.setProperty('background-image', `url(${image})`);
  flyToCartElement.style.setProperty('--start-opacity', '0');
  flyToCartElement.source = button;
  flyToCartElement.destination = cartIcon;

  document.body.appendChild(flyToCartElement);
}

/**
 * Keeps separate custom forms for the same product on the same variant.
 * This covers product heroes, sticky buttons, and final CTA forms.
 *
 * @param {Event} event
 */
function syncProductVariant(event) {
  if (isSyncingVariant) return;

  const sourceControl = event.target;
  if (!(sourceControl instanceof HTMLInputElement || sourceControl instanceof HTMLSelectElement)) return;
  if (sourceControl.name !== 'id') return;

  const sourceComponent = sourceControl.closest(customProductFormSelector);
  const productId = sourceComponent?.dataset.productId;
  if (!productId || !sourceControl.value) return;

  const sourceImage =
    sourceControl instanceof HTMLSelectElement
      ? sourceControl.selectedOptions[0]?.dataset.customCartImage
      : sourceControl.dataset.customCartImage;

  isSyncingVariant = true;

  try {
    for (const component of document.querySelectorAll(customProductFormSelector)) {
      if (component.dataset.productId !== productId) continue;

      if (sourceImage) component.dataset.customCartImage = sourceImage;
      if (component === sourceComponent) continue;

      const targetControl = component.querySelector('[name="id"]');
      if (
        !(targetControl instanceof HTMLInputElement || targetControl instanceof HTMLSelectElement) ||
        targetControl.value === sourceControl.value
      ) {
        continue;
      }

      targetControl.value = sourceControl.value;
      targetControl.dispatchEvent(new Event('change', { bubbles: true }));
    }
  } finally {
    isSyncingVariant = false;
  }
}

document.addEventListener('click', handleCustomCartAnimation);
document.addEventListener('change', syncProductVariant);
